import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input } from '~/components/Form';
import { t, validCharacters } from '~/helpers';
import { storeData, updateData } from '~/store/modules/distribuidora/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.distribuidora);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        cnpjdistribuidoranfe: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(14, t('s.geral.validacao.tamanhomaximo').replace('%s', 14))
          .matches(
            /^[0-9A-Za-z]+$/,
            t('s.configuracao.geral.naopodecontercaracterespecial')
          ),
        nomedistribuidoranfe: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="cnpjdistribuidoranfe"
            label={t('s.configuracao.posto.cnpjposto')}
            variant="outlined"
            fullWidth
            disabled={!create}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Input
            name="nomedistribuidoranfe"
            label={t('s.configuracao.posto.nomedistribuidoraposto')}
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
